import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast, ToastOptions } from 'react-toastify'

import { FormHandles, Scope } from '@unform/core'
import {
  ResumoDeDocumentosDeSaidaMapper,
  selecaoDeDocumentosParaEnvio,
  UploadDocumentos,
  useRelacaoDeDocumentos
} from 'src/compartilhados'
import { RelacaoDocumentosParceiroCertificacao } from 'src/compartilhados/modulos/gestao-de-documentos/data/relacao-de-documentos-parceiro-certificacao.data'
import {
  AutenticacaoContainer,
  Botao,
  Cabecalho,
  Carregando,
  DadosAlteracaoCPFCNPJ,
  ErroLayoutContainer,
  focarPrimeiroCampoComErro,
  FormUnform,
  IconeModalSucesso,
  InputUnform,
  Modal,
  ModalAlteracaoCPFCPNJ,
  ModalRef,
  SelectUnform,
  Spacer,
  SubTitulo,
  Visao
} from 'src/componentes'
import { CnpjInputUnform } from 'src/componentes/unform/input/cnpj'
import { SELECT_PAISES } from 'src/dados-estaticos'
import { ContainerMedio } from 'src/paginas/matricula/styles'
import { RotasParceiroCertificacao } from 'src/rotas'
import { RotasProfessor } from 'src/rotas/professor'
import { Api } from 'src/servicos'
import { PaisResidencia, Professor } from 'src/tipos'
import { ParceiroCertificacao } from 'src/tipos/parceiroCertificacao-usuario'

import { ContainerCertificacao } from '../styles'
import DocumentosParceiroCertificacao, {
  DocumentosParceiroCertificacaoHandles
} from './componentes/documentos/documentos-parceiro-certificacao'
import { schema } from './schema'
import {
  ContainerBotoes,
  Linha,
  ContainerDadosGrande,
  ContainerDadosMedio,
  ContainerPrincipal,
  Conteudo,
  Secao,
  TituloPrincipal
} from './styles'

export const PaginaMeuCadastroParceiroCertificacao: React.FC = () => {
  const formRef = useRef<FormHandles>(null)
  const { id } = useParams<{ id: string }>()
  const { visao } = AutenticacaoContainer.useContainer()
  const documentosRef = useRef<DocumentosParceiroCertificacaoHandles>(null)
  const modalAvisoEmailRef = useRef<ModalRef>(null)
  const modalAlteracaoCPF = useRef<ModalRef>()
  const { usuario } = AutenticacaoContainer.useContainer()
  const history = useHistory()
  const [dadosIniciais, definirDadosIniciais] = useState<Professor>(null)
  const [pronto, definirPronto] = useState(false)
  const [carregando, definirCarregando] = useState(false)

  const { documentos, atualizar, reiniciar } = useRelacaoDeDocumentos(
    RelacaoDocumentosParceiroCertificacao
  )

  const [paisResidencia, definirPaisResidencia] = useState<string>(
    dadosIniciais?.paisResidencia === 'brasil'
      ? PaisResidencia.Brasil
      : PaisResidencia.Outro
  )

  const erroAoEnviarDocumentos = 'Erro ao enviar documentos.'
  const erroAoAtualizarDocumentos = 'Erro ao atualizar documentos.'
  const erroAoEnviarMotivoAlteracaoAprovado = 'Erro ao enviar motivo alteração'

  const toastOptions = { type: 'error' } as ToastOptions

  const uploadDeCriacao = async (
    alunoId: string,
    documentos: UploadDocumentos[]
  ): Promise<void> => {
    try {
      const formulario = ResumoDeDocumentosDeSaidaMapper(documentos)
      const resposta = await Api.EnviarDocumentosParceiroCertificacao(
        alunoId,
        formulario
      )

      if (!resposta) {
        toast(erroAoEnviarDocumentos, toastOptions)
      }
    } catch (erro) {
      toast(erroAoEnviarDocumentos, toastOptions)
    }
  }

  const uploadDeEdicao = async (
    alunoId: string,
    documentos: UploadDocumentos[]
  ): Promise<void> => {
    try {
      const formulario = ResumoDeDocumentosDeSaidaMapper(documentos)
      const resposta = await Api.EditarDocumentosParceiroCertificacao(
        alunoId,
        formulario
      )

      if (resposta) {
        const documentosAprovados = documentos.filter(
          x => x.motivoAlteracaoAprovado
        )

        if (documentosAprovados?.length > 0) {
          try {
            await Api.AlteracaoAprovado(alunoId, documentosAprovados)
          } catch {
            toast(erroAoEnviarMotivoAlteracaoAprovado, toastOptions)
          }
        }
      } else {
        toast(erroAoAtualizarDocumentos, toastOptions)
      }
    } catch (erro) {
      toast(erroAoAtualizarDocumentos, toastOptions)
    }
  }

  const buscarCep = async (cep: string) => {
    const endereco = await Api.BuscarCep(cep)

    if (endereco) {
      formRef.current?.setFieldValue('endereco.bairro', endereco.bairro)
      formRef.current?.setFieldValue('endereco.logradouro', endereco.logradouro)
      formRef.current?.setFieldValue('endereco.cidade', endereco.cidade)
      formRef.current?.setFieldValue('endereco.uf', endereco.uf)
      formRef.current?.setFieldValue('endereco.numero', endereco.numero)
      document.getElementById('ipt_numero')?.focus()
    } else {
      formRef.current?.setFieldValue('endereco.bairro', '')
      formRef.current?.setFieldValue('endereco.logradouro', '')
      formRef.current?.setFieldValue('endereco.cidade', '')
      formRef.current?.setFieldValue('endereco.uf', '')
      formRef.current?.setFieldValue('endereco.complemento', '')
      formRef.current?.setFieldValue('endereco.numero', '')
    }
  }

  const acaoSucesso = async (dados: ParceiroCertificacao) => {
    definirCarregando(true)
    try {
      const { edicoes, criacoes, contador } = selecaoDeDocumentosParaEnvio(
        documentos
      )
      await Api.EditarParceiroCertificacaoPorIdUsuario(usuario.id, dados)
      if (contador !== 0) {
        if (criacoes.length > 0) {
          await uploadDeCriacao(usuario.id, criacoes)
        }

        if (edicoes.length > 0) {
          await uploadDeEdicao(usuario.id, edicoes)
        }
      }
      toast('Dados editados com sucesso!', {
        type: 'success'
      })
      history.push(RotasParceiroCertificacao.Dashboard)
    } catch (erro) {
      toast('Ops! Aconteceu um erro. Tente novamente.', { type: 'error' })
    } finally {
      definirCarregando(false)
    }
  }

  const obterParceiroCertificacao = async (): Promise<void> => {
    definirPronto(false)
    try {
      const resposta = await Api.ObterParceiroCertificacaoPorIdUsuario(id)
      definirDadosIniciais(resposta)
    } catch {
      toast('Erro ao obter dados do usuário.', {
        type: 'error'
      })
    } finally {
      definirPronto(true)
    }
  }

  const atualizarDadosFormulario = (dados: DadosAlteracaoCPFCNPJ) => {
    if (dados.cpf) formRef.current?.setFieldValue('cpf', dados.cpf)
  }

  useEffect(() => {
    obterParceiroCertificacao()
  }, [])

  useEffect(() => {
    if (dadosIniciais?.paisResidencia) {
      formRef.current?.setFieldValue(
        'endereco.paisResidencia',
        dadosIniciais.paisResidencia === 'brasil'
          ? PaisResidencia.Brasil
          : PaisResidencia.Outro
      )
      definirPaisResidencia(
        dadosIniciais.paisResidencia === 'brasil'
          ? PaisResidencia.Brasil
          : PaisResidencia.Outro
      )
    }
  }, [dadosIniciais])

  return (
    <>
      {pronto ? (
        <ContainerCertificacao>
          <ContainerPrincipal>
            <Cabecalho>
              <TituloPrincipal>Atualização de Cadastro</TituloPrincipal>
            </Cabecalho>
            <Conteudo>
              <FormUnform
                ref={formRef}
                acaoSucesso={acaoSucesso}
                acaoFalha={focarPrimeiroCampoComErro}
                dadosIniciais={dadosIniciais}
                schema={schema}
              >
                <Secao>
                  <SubTitulo texto="Dados Pessoais" />
                  <Spacer padding="13px 0px" />
                  <Linha>
                    <ContainerMedio>
                      <InputUnform
                        id="ipt_razao_social"
                        name="nome"
                        label="Razão Social"
                        disabled={visao !== Visao.ParceiroCertificacao}
                        obrigatorio
                      />
                    </ContainerMedio>
                    <ContainerMedio>
                      <CnpjInputUnform
                        id="ipt_cnpj"
                        name="cnpj"
                        label="CNPJ"
                        disabled={visao !== Visao.ParceiroCertificacao}
                        obrigatorio
                      />
                    </ContainerMedio>
                  </Linha>
                  <Linha>
                    <ContainerDadosGrande>
                      <InputUnform
                        id="nomeSocial"
                        name="nomeSocial"
                        label="Nome Fantasia"
                        disabled={visao !== Visao.ParceiroCertificacao}
                        maxLength={200}
                      />
                    </ContainerDadosGrande>
                  </Linha>
                </Secao>
                <Secao>
                  <SubTitulo texto="Residência" />
                  <Scope path="endereco">
                    <Linha>
                      <ContainerDadosMedio>
                        <SelectUnform
                          name="paisResidencia"
                          id="paisResidencia"
                          label="Nacionalidade"
                          disabled={visao !== Visao.ParceiroCertificacao}
                          valorAlterado={opcao =>
                            definirPaisResidencia(opcao ? opcao.id : '')
                          }
                          opcoes={SELECT_PAISES}
                        />
                      </ContainerDadosMedio>

                      {paisResidencia === PaisResidencia.Brasil ? (
                        <ContainerDadosMedio>
                          <InputUnform
                            type="text"
                            name="cep"
                            label="CEP"
                            mascara="99999999"
                            disabled={visao !== Visao.ParceiroCertificacao}
                            onBlur={event => buscarCep(event.target.value)}
                          />
                        </ContainerDadosMedio>
                      ) : null}
                    </Linha>

                    <ContainerDadosGrande>
                      <InputUnform
                        type="text"
                        name="logradouro"
                        label="Logradouro"
                        disabled={visao !== Visao.ParceiroCertificacao}
                        maxLength={200}
                      />
                    </ContainerDadosGrande>

                    <Linha>
                      <ContainerDadosMedio>
                        <InputUnform
                          type="text"
                          name="complemento"
                          label="Complemento"
                          disabled={visao !== Visao.ParceiroCertificacao}
                          maxLength={200}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <InputUnform
                          type="text"
                          name="bairro"
                          label="Bairro"
                          disabled={visao !== Visao.ParceiroCertificacao}
                          maxLength={200}
                        />
                      </ContainerDadosMedio>
                    </Linha>
                    <Linha>
                      <ContainerDadosMedio>
                        <InputUnform
                          type="text"
                          name="cidade"
                          label="Cidade"
                          disabled={visao !== Visao.ParceiroCertificacao}
                          maxLength={200}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <InputUnform
                          type="text"
                          name="numero"
                          id="ipt_numero"
                          label="Número"
                          disabled={visao !== Visao.ParceiroCertificacao}
                          maxLength={200}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <InputUnform
                          type="text"
                          name="uf"
                          label="UF"
                          disabled={visao !== Visao.ParceiroCertificacao}
                          maxLength={10}
                        />
                      </ContainerDadosMedio>
                    </Linha>
                    <ContainerDadosGrande>
                      <ErroLayoutContainer.Provider>
                        <DocumentosParceiroCertificacao
                          ref={documentosRef}
                          parceiroCertificacaoId={id}
                          documentos={documentos}
                          atualizar={atualizar}
                          reiniciar={reiniciar}
                        />
                      </ErroLayoutContainer.Provider>
                    </ContainerDadosGrande>
                  </Scope>
                </Secao>
                <Spacer padding="10px 0px" />
                <ContainerBotoes>
                  <Botao
                    type="button"
                    texto={
                      visao === Visao.ParceiroCertificacao
                        ? 'Cancelar'
                        : 'Voltar'
                    }
                    tema="Secundario"
                    disabled={carregando}
                    onClick={() => history.goBack()}
                  />
                  {visao === Visao.ParceiroCertificacao && (
                    <Botao
                      type="submit"
                      texto="Salvar"
                      carregando={carregando}
                    />
                  )}
                </ContainerBotoes>
              </FormUnform>
            </Conteudo>
          </ContainerPrincipal>
        </ContainerCertificacao>
      ) : (
        <ContainerCertificacao>
          <Carregando texto="Carregando dados do usuário..." />
        </ContainerCertificacao>
      )}
      <Modal
        ref={modalAvisoEmailRef}
        backdrop
        id="modal-aviso-email"
        icone={<>{IconeModalSucesso}</>}
        titulo="E-mail alterado!"
        acaoPrimaria={{
          titulo: 'OK',
          tipo: 'button',
          acao: () => {
            modalAvisoEmailRef?.current?.fechar()
            history.push(RotasProfessor.Dashboard)
          }
        }}
      >
        <p style={{ textAlign: 'center' }}>
          A solicitação do endereço de E-mail foi gerada. Acesse o novo endereço
          de e-mail cadastrado e confirme a alteração pelo link enviado.
        </p>
      </Modal>
      <ModalAlteracaoCPFCPNJ
        ref={modalAlteracaoCPF}
        acaoPrimaria={atualizarDadosFormulario}
        backdrop
      />
    </>
  )
}
